import { BbchStageBase } from 'farmdok-rest-api';

export function formatBbchStageDescription(stage: Pick<BbchStageBase, 'description' | 'macroStageName'>): string {
  const macroStageName = stage.macroStageName?.trim() ?? '';
  const description = stage.description?.trim() ?? '';

  if (macroStageName && description) {
    return `${macroStageName} - ${description}`;
  }

  return macroStageName || description;
}

export function formatBbchMacroStageHeader(macroStage: number, macroStageName?: string | null): string {
  const macroStageCode = `${Math.floor(macroStage)}X`;
  const trimmedMacroStageName = macroStageName?.trim() ?? '';

  if (!trimmedMacroStageName) {
    return `BBCH ${macroStageCode}`;
  }

  return `BBCH ${macroStageCode} - ${trimmedMacroStageName}`;
}

export function getBbchMacroStage(stage: Pick<BbchStageBase, 'bbchCode' | 'macroStage'>): number | null {
  if (typeof stage.macroStage === 'number' && !Number.isNaN(stage.macroStage) && stage.macroStage >= 0) {
    return Math.floor(stage.macroStage);
  }

  if (typeof stage.bbchCode === 'number' && !Number.isNaN(stage.bbchCode) && stage.bbchCode >= 0) {
    return Math.floor(stage.bbchCode / 10);
  }

  return null;
}
